import { FieldTypes } from '../../constants/FieldTypes'
import { addFieldRow } from '../../fields/utils'
import { DropdownField, FieldMap, NumberField, TextField } from '../../types/forms/fields'
import { CervicalConsistency, CervicalPosition, MembraneStatus } from '../types/cervicalExam'

const dilationField: NumberField = {
  type: FieldTypes.NUMBER,
  placeholder: 'Dilation',
  unit: 'cm',
  min: 0,
  max: 10,
  step: 0.5,
  precision: 1,
}

const effacementField: NumberField = {
  type: FieldTypes.NUMBER,
  placeholder: 'Effacement',
  unit: '%',
  min: 0,
  max: 100,
}

const stationField: NumberField = {
  type: FieldTypes.NUMBER,
  placeholder: 'Station',
  min: -5,
  max: 5,
}

const positionField: DropdownField<CervicalPosition> = {
  type: FieldTypes.DROPDOWN,
  placeholder: 'Position',
  inputType: 'radio',
  options: [
    { text: 'Posterior', id: CervicalPosition.POSTERIOR },
    { text: 'Mid-Position', id: CervicalPosition.MID_POSITION },
    { text: 'Anterior', id: CervicalPosition.ANTERIOR },
  ],
}

const consistencyField: DropdownField<CervicalConsistency> = {
  type: FieldTypes.DROPDOWN,
  placeholder: 'Consistency',
  inputType: 'radio',
  options: [
    { text: 'Firm', id: CervicalConsistency.FIRM },
    { text: 'Medium', id: CervicalConsistency.MEDIUM },
    { text: 'Soft', id: CervicalConsistency.SOFT },
  ],
}

const membranesField: DropdownField<MembraneStatus> = {
  type: FieldTypes.DROPDOWN,
  placeholder: 'Membranes',
  inputType: 'radio',
  options: [
    { text: 'Intact', id: MembraneStatus.INTACT },
    { text: 'SROM (Spontaneous)', id: MembraneStatus.SROM },
    { text: 'AROM (Artificial)', id: MembraneStatus.AROM },
  ],
}

const presentingPartField: TextField = {
  type: FieldTypes.TEXT,
  placeholder: 'Presenting Part',
}

export const cervicalExamField: FieldMap = {
  name: 'Cervical Exam',
  children: {
    dilation: addFieldRow(dilationField, { index: 0, flex: 1 }),
    effacement: addFieldRow(effacementField, { index: 0, flex: 1 }),
    station: addFieldRow(stationField, { index: 0, flex: 1 }),
    position: addFieldRow(positionField, { index: 1, flex: 1 }),
    consistency: addFieldRow(consistencyField, { index: 1, flex: 1 }),
    membranes: addFieldRow(membranesField, { index: 1, flex: 1 }),
    presentingPart: presentingPartField,
  },
}
